function isFunction(fun) {
    return typeof(fun) === 'function';
}

export default function isDate(value) {
    return Boolean(value) && isFunction(value.getTime) && isFunction(value.getMonth);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@telerik/kendo-intl/dist/es/common/is-date.js
// module id = 478
// module chunks = 30